var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("navbar"),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("router-link", { attrs: { to: "top" } }, [
                _vm._v(_vm._s(_vm.$t("ordertop.myhome")))
              ]),
              _vm._v(
                " / " +
                  _vm._s(_vm.$t("Settingspage.SettingsTop")) +
                  "\n        "
              ),
              _c("div", { staticClass: "card mt-4" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.$t("Settingspage.UpdatePassword")))
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v(_vm._s(_vm.$t("Settingspage.UpdatePsdTips")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-facebook",
                      on: { click: _vm.updatePassword }
                    },
                    [_vm._v(_vm._s(_vm.$t("Settingspage.UpdateButton")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card mt-4" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.$t("Settingspage.UpdateTwofactauth")))
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v(_vm._s(_vm.$t("Settingspage.UpdateTwofactauthTips")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-facebook",
                      on: { click: _vm.updateTwoFactAuth }
                    },
                    [_vm._v(_vm._s(_vm.$t("Settingspage.UpdateButton")))]
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("copyright"),
      _vm._v(" "),
      _c("updatepassword"),
      _vm._v(" "),
      _c("updatetwofactauth")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-818f7fb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-818f7fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operator/info.vue
// module id = null
// module chunks = 